<div fxFlex class="box">
  <div class="header">
    <div class="section-title">Consumption filters</div>
    <div fxFlex></div>
    <div class="search" [ngClass]="{'active': searchTerm}">
      <mat-form-field>
        <mat-label>Search</mat-label>
        <input type="text" matInput placeholder="" autocomplete="off" (keyup)="searchConsumptionFilter()" [(ngModel)]="searchTerm">
      </mat-form-field>
    </div>
    <lib-button (buttonClick)="addConsumptionFilter()" icon="add" tooltip="Add consumption filter">Add filter</lib-button>
    <lib-button variant="icon" icon="more_vert" tooltip="More actions" [matMenuTriggerFor]="appMenu"></lib-button>

    <mat-menu #appMenu="matMenu">
      <button mat-menu-item type="button" (click)="testFuzzy()" matTooltip="Test fuzzy">
        <mat-icon>settings_ethernet</mat-icon> Test fuzzy matching
      </button>
    </mat-menu>

  </div>
  <form class="content" #form="ngForm">
    <ngx-datatable (sort)="onSort()" #datatable class="material" [rows]="consumptionFilters" [columnMode]="ColumnMode.force" [sortType]="SortType.single"
      [headerHeight]="35" [rowHeight]="'auto'">

      <ngx-datatable-column name="Wildcard" [sortable]="true" prop="wildCard" [resizeable]="false" [canAutoResize]="true">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <mat-form-field [ngClass]="{'hidden': !row.visible}">
            <mat-label>Wildcard</mat-label>
            <input type="text" matInput placeholder="" required min="0" max="1000" (input)="onInput($event, row, 'wildCard')" [value]="row.wildCard"
              autocomplete="off" name="wildCard_{{row.guid}}" required>
          </mat-form-field>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Score" [sortable]="true" prop="score" [width]="75" [resizeable]="false" [canAutoResize]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <mat-form-field [ngClass]="{'hidden': !row.visible}">
            <mat-label>Score</mat-label>
            <input matInput type="number" placeholder="" required min="0" max="100" step=".01"
              (input)="onInput($event, row, 'score')" [value]="row.score" autocomplete="off" name="score_{{row.guid}}" required>
          </mat-form-field>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Match algorithm" [sortable]="true" prop="algorithm" [width]="150" [resizeable]="false" [canAutoResize]="false">
        <ng-template let-row="row" ngx-datatable-cell-template >
          @if (toggle) {
            <mat-form-field [ngClass]="{'hidden': !row.visible}" >
              <mat-label>Match algorithm</mat-label>
              <mat-select  placeholder="" required [(ngModel)]="row.algorithm" name="algorithm_{{row.guid}}">
                @for (a of matchAlgorithms; track a) {
                  <mat-option  [value]="a.id" [matTooltip]="a.text">
                    {{ a.text }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [sortable]="false" [width]="125" [resizeable]="false" [canAutoResize]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <mat-form-field [ngClass]="{'hidden': !row.visible}">
            <mat-label>Fuzzy treshold</mat-label>
            <input matInput type="number" placeholder="" required min="1" max="100" step=".01"
              (input)="onInput($event, row, 'fuzzyTreshold')" [value]="row.fuzzyTreshold" autocomplete="off" name="fuzzyTreshold_{{row.guid}}" required>
          </mat-form-field>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [sortable]="false" [width]="50" [resizeable]="false" [canAutoResize]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <lib-button variant="icon" color="primary" [ngClass]="{'hidden': !row.visible}" (buttonClick)="removeConsumptionFilter(row.guid)" icon="delete" tooltip="Remove consumption filter"></lib-button>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
    @if (searchTerm) {
      <mat-error>Showing <strong>{{searchCount}}</strong>/{{consumptionFilters.length}}</mat-error>
    }
    @if (form.touched && !form.valid) {
      <mat-error>One or more filters are invalid</mat-error>
    }

  </form>
</div>